import classNames from 'classnames';

import s from './OutfitHeaderSkeleton.sss';

type OutfitHeaderSkeletonProps = {
  className?: string;
};

export const OutfitHeaderSkeleton: React.FC<OutfitHeaderSkeletonProps> = ({
  className,
}) => (
  <>
    <div className={classNames(s.root, className)}>
      <div className={s.imageWrapper}>
        <div className={s.image} />
      </div>
      <div className={s.aside}>
        <p className={s.title} />
        <div className={s.itemsWrapper}>
          <div className={s.item} />
          <div className={s.item} />
          <div className={s.item} />
          <div className={s.item} />
        </div>
      </div>
    </div>
  </>
);
